import type { RecordView } from '@kit/sync/types/record-view';
import type { Item } from '../schemas/item';

/** What everything in the inventory cost. */
export function inventoryValue(items: readonly RecordView<Item>[]): number {
  return items.reduce((sum, item) => sum + (item.data.price_cents ?? 0), 0);
}
